import React from "react";
import { useProductsSelectionStore } from "../../stores/productsSelectionStore";
import ProductsUpdateStatusSelector from "./ProductsUpdateStatusSelector";
import { InfoModal, PermissionWrapper } from "components";
import { noImage } from "assets";
import { formatUah } from "utils";

// Компонент відображення рядка таблиці сторінки "Товари постачальників"
const ProductRow = ({ product, onStatusUpdate, onImageClick }) => {
  // Отримуємо дані та дії зі стору вибору
  const isSelectionModeActive = useProductsSelectionStore(
    (state) => state.isSelectionModeActive,
  );
  const selectedSkus = useProductsSelectionStore((state) => state.selectedSkus);
  const toggleSku = useProductsSelectionStore((state) => state.toggleSku);

  const isSelected = selectedSkus.includes(product.article);
  // Конфігурація інформації для модалки
  const infoArray = [
    {
      label: "Ціна з таблиці виключень",
      value: product.exception_price
        ? formatUah(product.exception_price)
        : "Не вказана",
    },
    {
      label: "Рекомендована ціна",
      value: product.reco_price ? formatUah(product.reco_price) : "Не вказана",
    },
    {
      label: "Кількість на складі",
      value: product.stock_quantity ?? "Не вказана",
    },
    {
      label: "Ціна постачальника",
      value: product.supplier_price ? formatUah(product.supplier_price) : "Не вказана",
    },
    {
      label: "Наявність постачальника",
      value: product.supplier_available ? "Наявний" : "Не наявний",
    },
  ];

  return (
    <tr key={product.article}>
      {isSelectionModeActive && (
        <td className="selection">
          <input
            className="focus-checkbox"
            type="checkbox"
            checked={isSelected}
            onChange={() => toggleSku(product.article)}
            title="Обрати"
          />
        </td>
      )}
      <td>{product.article}</td>
      <td className="photo">
        <img
          src={product.img_url || noImage}
          alt={product.name}
          className={`${product.img_url ? "clickable" : ""}`}
          onClick={() => onImageClick(product.img_url)}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = noImage;
          }}
        />
      </td>
      <td className="name">
        <span>{product.name || "---"}</span>
        {product.category_name && (
          <span className="badge">{product.category_name}</span>
        )}
      </td>
      <td>
        <InfoModal info={infoArray}>{formatUah(product.price)}</InfoModal>
      </td>
      <td>{product.available}</td>

      <PermissionWrapper requiredPermission="products:edit">
        <td>
          <ProductsUpdateStatusSelector
            article={product.article}
            currentStatus={product.update_status}
            onStatusUpdate={onStatusUpdate}
          />
        </td>
      </PermissionWrapper>
    </tr>
  );
};

export default ProductRow;
